// extracted by mini-css-extract-plugin
module.exports = {"promo":"styles_promo__2YRkb","urgency":"styles_urgency__147gL","velocity":"styles_velocity__zn77P","banner":"styles_banner__36-zz"};